// Client-side session simulation. Backend integration point:
// replace with Supabase auth session (supabase.auth.getSession / onAuthStateChange).

export interface SessionUser {
  username: string;
  galaxy_name: string;
  role: 'admin' | 'member';
  model: string;
  show_money: boolean;
  disabled: boolean;
  must_change_password: boolean;
}

const SESSION_KEY = 'adgalaxy_session';

export function getSession(): SessionUser | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}

export function setSession(user: SessionUser): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(user));
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(SESSION_KEY);
}

export function updateSession(patch: Partial<SessionUser>): void {
  const current = getSession();
  if (!current) return;
  setSession({ ...current, ...patch });
}